// components/AddressModal.tsx
import React, { useEffect, useState, useRef } from "react";
// import styled from "styled-components";

interface AddressModalProps {
  onClose: () => void;
  onComplete: (data: {
    roadAddress: string;
    jibunAddress: string;
    buildingCode: string;
  }) => void;
}

declare global {
  interface Window {
    daum: {
      Postcode: new (options: {
        oncomplete: (data: {
          roadAddress: string;
          jibunAddress: string;
          buildingCode: string;
        }) => void;
        width: string;
        height: string;
      }) => {
        embed: (container: HTMLElement) => void;
      };
    };
  }
}

const AddressModal: React.FC<AddressModalProps> = ({ onClose, onComplete }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  useEffect(() => {
    // Load the Daum Postcode script
    const script = document.createElement("script");
    script.src =
      "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
    script.async = true;
    script.onload = () => setIsScriptLoaded(true);
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (!isScriptLoaded || !containerRef.current) return;

    try {
      const postcode = new window.daum.Postcode({
        oncomplete: (data) => {
          onComplete(data);
          onClose();
        },
        width: "100%",
        height: "100%",
      });

      postcode.embed(containerRef.current);
    } catch (error) {
      console.error("Error initializing Daum Postcode:", error);
    }
  }, [isScriptLoaded, onClose, onComplete]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-[999] flex justify-center items-center">
      <div className="relative w-[500px] h-[600px] bg-white p-4 box-border rounded-xl">
        <div ref={containerRef} className="w-full h-full" />
        <button
          className="absolute bottom-2.5 right-2.5 px-4 py-2 bg-blue-600 text-white rounded transition hover:bg-blue-700"
          onClick={onClose}
        >
          닫기
        </button>
      </div>
    </div>
  );
};

export default AddressModal;
